/*
 * @Author: wp
 * @Date: 2022-12-29 15:31:28
 * @LastEditors: huangyi
 * @LastEditTime: 2023-12-04 09:40:22
 * @Descripttion:
 */
module.exports = {
    // 卖家商品状态
    orderStatusBySeller: {
        WAIT_PUBLISH: 'WAIT_PUBLISH', // 待发布
        ON_STAND: 'ON_STAND', // 上架
        TRADING: 'TRADING', // 交易中
        FORCE_DOWN_STAND: 'FORCE_DOWN_STAND', // 强制下架（已下架）
        ONESELF_DOWN_STAND: 'ONESELF_DOWN_STAND', // 自行下架
        WAIT_VERIFY: 'WAIT_VERIFY', // 待审核
        VERIFY_FAIL: 'VERIFY_FAIL', // 审核失败
        BEAN_SOLD: 'BEAN_SOLD', // 已出售
        EDIT_GOODS: 'EDIT_GOODS' // 编辑商品
    },
    // 买家商品状态
    orderStatusByBuyer: {
        WAIT_PAY: 'WAIT_PAY', // 待支付
        CANCEL: 'CANCEL', // 已取消
        PAY_SUCCESS: 'PAY_SUCCESS', // 待成交（支付成功）
        COMPLETE: 'COMPLETE', // 已成交
        REFUND_CANCEL: 'REFUND_CANCEL' // 已退款
    },
    // 消息状态跳转页面
    messagePath: {
        GOODS_ON_STAND: 'GOODS_ON_STAND', // 您提交的商品已上架，点击查看详情(已上架)
        GOODS_FORCE_DOWN_STAND: 'GOODS_FORCE_DOWN_STAND', // 您发布的商品已被平台强制下架，点击查看详情（强制下架）
        GOODS_RESTORE_ON_STAND: 'GOODS_RESTORE_ON_STAND', // 您被平台强制下架的商品已恢复上架，点击查看详情(已上架)
        GOODS_UPDATE_BY_STAFF: 'GOODS_UPDATE_BY_STAFF', // 您的商品已由客服重新编辑，点击查看详情(已上架)
        GOODS_VERIFY_FAIL: 'GOODS_VERIFY_FAIL', // 您提交的商品审核失败，点击查看详情
        GOODS_BEAN_SOLD: 'GOODS_BEAN_SOLD', // 您发布的商品已成功出售，点击查看详情
        GOODS_BEAN_DEAL: 'GOODS_BEAN_DEAL', // 您购买的商品已成交，点击查看详情
        GOODS_CREATE_PROVE: 'GOODS_CREATE_PROVE', // 您购买的商品已生成包赔证明，点击查看详情
        GOODS_CANCEL_DEAL: 'GOODS_CANCEL_DEAL', // 您购买的商品已取消成交，点击查看详情
        WITHDRAWAL_SUCCESS: 'WITHDRAWAL_SUCCESS', // 您申请的提现已结算成功，点击查看详情
        WITHDRAWAL_FAIL: 'WITHDRAWAL_FAIL', // 您申请的提现已结算失败，点击查看详情
        BLACKLIST_EXAMINATION_PASS: 'BLACKLIST_EXAMINATION_PASS', // 您的举报申请已通过审核，点击查看详情
        BLACKLIST_EXAMINATION_FAIL: 'BLACKLIST_EXAMINATION_FAIL' // 您的举报申请未通过审核，点击查看详情
    },
    // 砍价商品状态
    bargainStatus: {
        MY_BARGAIN_ENUM: {
            WAIT_PAY: 'WAIT_PAY', //待支付
            PAY_FAIL: 'PAY_FAIL', //支付失败
            BUYER_QUOTATION: 'BUYER_QUOTATION', //待回复
            BUYER_CANCEL: 'BUYER_CANCEL', //取消订单
            SELLER_COUNTER_OFFER: 'SELLER_COUNTER_OFFER', //卖家还价
            BUYER_QUOTATION_AGAIN: 'BUYER_QUOTATION_AGAIN', //二次还价
            SELLER_REFUSE: 'SELLER_REFUSE', //卖家拒绝
            SELLER_AGREE: 'SELLER_AGREE', //卖家同意
            BUYER_AGREE: 'BUYER_AGREE', //已同意
            HAVING_DEAL: 'HAVING_DEAL', //砍价成功
            SELLER_CANCEL: 'SELLER_CANCEL', //卖家取消
            BIDDING_FAILED: 'BIDDING_FAILED', //竞价失败
            DOWN_STAND: 'DOWN_STAND', //商品已下架
            BEAN_SOLD: 'BEAN_SOLD', //已出售
            ORDER_TIME_OUT_CANCEL: 'ORDER_TIME_OUT_CANCEL', //支付超时取消
            OnLine: 2, //在线支付
            OffLine: 1 //线下支付
        },
        //买家报价
        BUYER_BARGAIN_ENUM: {
            WAIT_PAY: 'WAIT_PAY', //待买家支付
            BUYER_QUOTATION: 'BUYER_QUOTATION', //待处理
            SELLER_COUNTER_OFFER: 'SELLER_COUNTER_OFFER', //已还价
            SELLER_AGREE: 'SELLER_AGREE', //已同意
            BUYER_AGREE: 'BUYER_AGREE', //买家同意
            SELLER_CANCEL: 'SELLER_CANCEL', //卖家取消
            BUYER_QUOTATION_AGAIN: 'BUYER_QUOTATION_AGAIN', //二次报价
            HAVING_DEAL: 'HAVING_DEAL' //砍价成功
        }
    },
    RestrictMallCode: {
        ALL_BUY: 'ALL_BUY', // 限制购买
        AGENCY_BUY: 'AGENCY_BUY', // 限制中介下单
        BARGAIN_CREATE: 'BARGAIN_CREATE', // 限制砍价
        GOODS_SELL: 'GOODS_SELL' // 限制售卖
    },
    RestrictType: {
        PERPETUAL: 'PERPETUAL', // 永久
        DURATION: 'DURATION' // 临时
    }
}
